<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>

    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Pengajuan Sertifikat
    </CCardHeader>    

    <CCardBody>
      <CRow >        
        <div class="col-sm-6 col-xl-16">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Periode</label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="periode"
              @select="changePeriode"
              :options="dataPeriode"
              :loading="loading"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-6 col-xl-16">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Sertifikasi</label>
            <multiselect
              class="mulit-select"
              label="nama_sertifikasi"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              v-model="sertifikasi"
              @select="changeSertifikasi"
              :options="dataSertifikasi"
              :loading="loading"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12 mb-3">
          <div style="float:right">
            <button class="btn btn-info" @click="resetFilter">Reset Filter</button>&nbsp;
            <button class="btn btn-success" @click="filterData">Terapkan</button>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." v-model="search" />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index + 1: index + indexed + 1}}</td>
            </template>

            <template #nama_lengkap="{ item, index }">
              <td
                class="py-2 text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)">
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>

            <template #no_anggota="{item}">
              <td class="py-2">{{item.no_anggota ? item.no_anggota : '-'}}</td>
            </template>

            <template #created_at="{item}">
              <td class="py-2">{{item.created_at | moment}}</td>
            </template>

            <template #status_pengajuan="{item}">
              <td class="py-2">
                <span v-if="item.status_pengajuan == 0"   class="font-weight-bold text-warning">
                  Proses Daftar 
                </span>
                <span v-else-if="item.status_pengajuan == 1"   class="font-weight-bold text-success">
                  Diterima 
                </span>
                <span class="font-weight-bold text-danger" v-else>
                  Tidak Diterima
                </span>
              </td>
            </template>
            <template #status_pengambilan="{item}">
              <td class="py-2 text-center">
                <span v-if="item.status_pengambilan == 0"   class="font-weight-bold text-warning">
                  Belum Diambil 
                </span>
                <span v-else-if="item.status_pengambilan == 1"   class="font-weight-bold text-success">
                  Sudah Diambil 
                </span>
                <span v-else-if="item.status_pengambilan == 2"   class="font-weight-bold text-warning">
                  Pengiriman
                </span>
                <span v-else-if="item.status_pengambilan == 3"   class="font-weight-bold text-warning">
                  Perwakilan
                </span>
                <span class="font-weight-bold text-warning" v-else>
                  Belum Diambil
                </span>
              </td>
            </template>
            <template #aksi={item}>
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_read">
                <CButton
                  v-c-tooltip="'Lihat Surat Kuasa'"
                  color="warning"
                  :disabled="item.status_pengambilan != '3'"
                   @click="lihatFile(item.surat_kuasa)"
                  :class="item.status_pengambilan != '3' ? 'btn btn-sm btn-secondary text-white mr-2' : 'btn btn-sm btn-info text-white mr-2' "  
                  class="btn-sm text-white" square>
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </CButton>
                </template>
                <template v-else>
                  <CButton
                    v-c-tooltip="'Lihat Surat Kuasa'"
                    color="secondary"
                    disabled
                    class="btn-sm text-white" square>
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </CButton>
                </template>
                <button 
                  v-c-tooltip="'Ubah'" 
                  :disabled="item.status_dokumen == '0'"
                  :class="item.status_dokumen == '0' ? 'btn btn-sm btn-secondary text-white mr-2' : 'btn btn-sm btn-info text-white mr-2' "  
                  @click="verifPengajuan(item)">
                  <font-awesome-icon icon="edit" />
                </button>
                <template v-if="role_status && role_status.status_read">
                <router-link v-c-tooltip="'Lihat Dokumen'" class="btn btn-sm btn-warning text-white" square :to="'/sertifikasi/pengajuan-sertifikat/data-dokumen/'+item.id_pengajuan_penerbitan">
                  <font-awesome-icon icon="file" />
                </router-link>
                </template>
                <template v-else>
                <router-link v-c-tooltip="'Lihat Dokumen'" class="btn btn-sm btn-secondary text-white" 
                square :to="'/sertifikasi/pengajuan-sertifikat/data-dokumen/'+item.id_pengajuan_penerbitan"
                tag="button"
                :disabled="true"
                >
                  <font-awesome-icon icon="file" />
                </router-link>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
          />
        </CCol>
      </CRow>

      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
        @submit.prevent="postData"
      >
        <CForm>
          <CRow>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <select 
                name="id_outlet" 
                class="form-control mb-2"
                :class="{
                  'is-invalid': $v.formData.statusPengajuan.$error,
                }"
                v-model="formData.statusPengajuan">
                <option value="0" disabled>Pengajuan</option>
                <option value="1">Diterima</option>
                <option value="2">Tidak Diterima</option>
              </select>
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">Kode Sertifikat</label>
              <br />
              <input 
                type="text" 
                class="form-control" 
                id="" 
                :class="{
                  'is-invalid': $v.formData.kodeSertifikat.$error,
                }"
                v-model="formData.kodeSertifikat">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">No Sertifikat</label>
              <br />
              <input 
                type="number" 
                class="form-control" 
                id="" 
                :class="{
                  'is-invalid': $v.formData.noSertifikat.$error,
                }"
                v-model="formData.noSertifikat">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">Tanggal Pengambilan</label>
              <br />
              <input 
              type="date" 
              class="form-control" 
              id="" 
              :class="{
                'is-invalid': $v.formData.tanggalPengambilan.$error,
              }"
              v-model="formData.tanggalPengambilan" :min="today">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengajuan == '1'">
              <label for class="font-weight-bold">Status Pengambilan</label>
              <br />
              <select 
                name="id_outlet" 
                class="form-control mb-2"
                :class="{
                  'is-invalid': $v.formData.statusPengambilan.$error,
                }" 
                v-model="formData.statusPengambilan">
                <option value disabled selected>Pilih Status Pengambilan</option>
                <option value="0">Belum Diambil</option>
                <option value="1">Sudah Diambil</option>

                <option value="2">Pengiriman</option>
                <option value="3">Perwakilan</option>
              </select>
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengambilan == '2'">
              <label for class="font-weight-bold">No Resi</label>
              <br />
              <input type="text" v-model="formData.noResi" class="form-control" name="" id="">
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengambilan == '2' || formData.statusPengambilan == '3'">
              <label for class="font-weight-bold">Keterangan</label>
              <br />
              <textarea class="form-control" v-model="formData.keterangan" cols="30" rows="10"></textarea>
            </CCol>
            <CCol sm="12 mb-4" v-show="formData.statusPengambilan == '3'">
              <label for="" class="font-weight-bold">Surat Kuasa 
                <a href="#"  @click="lihatFile(formData.suratKuasaLink)" v-if="formData.suratKuasaLink != ''">(Lihat File)</a>
              </label>
              <br>
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  ref="uploadFileInformasiUmum"
                  @change="fileUpload"
                />
                  <!-- :required="actionPost == 'update'" -->

                <label
                  class="custom-file-label text-truncate"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                  >{{
                    typeof formData.suratKuasa === "string" ? formData.suratKuasa : formData.filename
                  }}</label
                >
              </div>
              <small class="text-danger"
                >(*File harus bertipe PDF max. 10MB)</small
              >
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Pengajuan Sertifikat</h6>
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail User -->
      <ModalDetailPesertaSertifikasi
        :modalDetail="modalDetail"
        :title="modalTitle"
        :formData="formData"
        @closeModalDetail="closeModalDetail($event)"
      />

    </CCardBody>
  </CCard>    
    <!-- end data kota/kab -->

    

</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { PaginationPengajuanSertifikat } from "@/mixins/paginationType/PaginationPengajuanSertifikat";
import { AlertUtils } from "@/mixins/AlertUtils";

import PengajuanPenerbitanSertifikatService from "@/services/sertifikasi/data-penerbitan-sertifikat.service"
import MasterSertifikasiService from "@/services/sertifikasi/master-sertifikasi.service";
import PeriodeService from '@/services/datamaster/periode.service';
import ModalDetailPesertaSertifikasi from "@/components/sertifikasi/datapeserta/ModalDetailPesertaSertifikasi";
import BaseUrl from "@/services/base-url";

import moment from 'moment'

const fields = [
  { key: "no" },
  {
    key: "no_anggota",
    label: "No Anggota",
  },
  {
    key: "nama_lengkap",
    label: "Nama",
  },
  {
    key: "nama_sertifikasi",
    label: "Nama Sertifikasi",
  },
  {
    key: "created_at",
    label: "Tanggal Pengajuan",
  },
  {
    key: "status_pengajuan",
    label: "Status Pengajuan",    
  },
  {
    key: "status_pengambilan",
    label: "Status Pengambilan",
    _style: "text-align: center",
  },
  {
    key: "aksi",
    _style: "width:12%; text-align: center",
  },
];

export default {
  mixins : [
    PaginationPengajuanSertifikat,
    AlertUtils,
  ],
  components: {
    ModalDetailPesertaSertifikasi
  },

  filters: {
    moment: function (date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },

  data() {
    return {       
      items: [],
      fields,
      dataSertifikasi : [],
      sertifikasi: {},
      periode : {},
      dataPeriode : [],
      modalTitle: '',
      today: '',
      formData : {
        id_pengajuan_penerbitan : "",
        kodeSertifikat : "",
        noSertifikat : "",
        noResi : "",
        suratKuasa : "",
        suratKuasaLink : "",
        filename : "",
        statusPengajuan : "1",
        tanggalPengambilan:'',
        statusPengambilan:''
      },
      modalVerif: false,
      loading: true,
      baseUrl: "",

      modalDetail: false,
      role_status: null
    }
  },
  validations : {
    formData : {
      kodeSertifikat : {required},
      noSertifikat : {required},
      statusPengajuan : {required},
      tanggalPengambilan : {required},
      statusPengambilan : {required}
    }
  },
  watch: {
    modalVerif: function() {
      if(this.modalVerif === false) {
        this.$v.$reset();
      }
    }
  },
  mounted() {
    this.baseUrl = BaseUrl();

    this.getPeriode();
    this.today = moment().format("YYYY-MM-DD")
    this.getSertifikasi();
    setTimeout(() => {      
      this.getData(this.currentPage, this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasi);
    }, 1000)    
    this.roleData();
  },
  methods : {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    lihatFile(item) {
      if (item != "" && item != null) {
        let routeData = this.baseUrl + "/files?filename="+item+"&path=sertifikasi@sertifikasi@suratkuasa"; 
        window.open(routeData, "_blank");
        return false;
      } 
      else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true,
        });
      }
    },
    changePeriode(e) {
      this.formFilter.periode = e.value
    },
    fileUpload(e) {
      this.formData.suratKuasa = e.target.files[0];
      this.formData.filename = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },

    changeSertifikasi(e) {      
      this.formFilter.idSertifikasi = e.id_sertifikasi;
    },

    filterData() {            
      this.getData("0", this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasi);
    },

    resetFilter() {      
      this.formFilter.periode = ''
      this.formFilter.idSertifikasi = ''
      this.sertifikasi = {}
      this.periode = {}
      this.items = []
    },

    getSertifikasi() {
      this.loading = true;
      MasterSertifikasiService.getSertifikasi(0,100000,'default')
        .then(response => {          
          this.dataSertifikasi = response.data.data.content;          
          this.dataSertifikasi.filter(el => el.idSertifikasi !== "default");
          this.sertifikasi = this.dataSertifikasi[0]          
          this.formFilter.idSertifikasi = this.sertifikasi.id_sertifikasi                    
          this.loading = false
        })
        .catch(error => {
          // comment console console.log(error);          
          this.loading = false
        });
    },

    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },

    closeModalDetail(e) {
      if(e === false) {
        this.modalDetail = false;
      }
    },
    
    getPeriode() {
      this.loading = true;
      PeriodeService.getPeriodePenerbitanSelect()
      .then(response => {
        this.dataPeriode = response.data.data
        var periode = this.dataPeriode.find(el => el.statusPenerbitan === '1' );          
        this.formFilter.periode = periode.value
        this.periode = periode        
        this.loading = false
      }).catch(error => {
        // comment console console.log(error)  
        this.loading = false      
      })
    },    
   
    postData(){
      this.$v.formData.$touch();
      if(this.$v.formData.$invalid) {
        return;
      } else {
        this.insertData();
      }
    },

    insertData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      if (typeof this.formData.suratKuasa === "string") {
        delete this.formData.suratKuasa;
      }
      PengajuanPenerbitanSertifikatService.putJadwalTc(this.formData)
        .then(response => {          
          this.modalVerif = false;
          loader.hide()          
          this.alertSuccess();                    
          this.getData(this.currentPage - 1, this.pageSize, this.search, this.formFilter.periode, this.formFilter.idSertifikasi);
        })        
        .catch(error => {
          this.modalVerif = false;
          this.alertError(error.response.data.message);
        })
    },

    verifPengajuan(item){
      this.modalVerif = true;   
      this.formData.id_pengajuan_penerbitan = item.id_pengajuan_penerbitan;
      this.formData.statusPengajuan = item.status_pengajuan;
      this.formData.kodeSertifikat = item.kode_sertifikat;
      this.formData.noSertifikat = item.no_sertifikat;
      this.formData.tanggalPengambilan = item.tanggal_pengambilan
      this.formData.statusPengambilan = item.status_pengambilan
      this.formData.suratKuasaLink = item.surat_kuasa
      this.formData.suratKuasa = item.surat_kuasa
      this.formData.noResi = item.no_resi && item.no_resi != 'null' ? item.no_resi : '' 
      this.formData.keterangan = item.keterangan
    },

    getData(currentPage, pageSize, search, periode, idSertifikasi){
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      PengajuanPenerbitanSertifikatService.getData(currentPage, pageSize, search, periode, idSertifikasi)
        .then(response => {                    
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide();
          this.loading = false
        }).catch(error => {
          this.alertError()
          loader.hide();
          this.loading = false
        })
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>